export default "__VITE_ASSET__C34U4S60__"